import { format, parse } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';

import {
  createWorkShift,
  deleteWorkShift,
  getWorkShift,
  updateWorkShift,
} from '../../../../app/store/actions/workShifts';
import OneClickButton from '../../../../components/form/button';
import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';
import {
  Panel,
  PanelBody, PanelFooter,
  PanelHeader,
} from '../../../../components/panel/panel';
import ROUTES from '../../../../config/routes';

class WorkShiftForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'detail',
      code: '',
      name: '',
      startTime: parse('00:00', 'HH:mm', new Date()),
      endTime: parse('00:00', 'HH:mm', new Date()),
      breakStartTime: parse('00:00', 'HH:mm', new Date()),
      breakEndTime: parse('00:00', 'HH:mm', new Date()),
      note: '',
      disableCode: true,
      disableName: true,
      disableWorkTime: true,
      disableBreakTime: true,
      disableNote: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    if (this.state.mode !== 'create') {
      await this.getWorkShiftSelected();
    }
  }

  getWorkShiftSelected = async () => {
    if (this.props.location.state.workShift) {
      const { workShift } = this.props.location.state;

      const workShiftSelected = await this.props.getWorkShift(workShift.id);

      if (workShiftSelected) {
        this.setState({
          workShiftId: workShiftSelected.id,
          code: workShiftSelected.code,
          name: workShiftSelected.name,
          startTime: parse(workShiftSelected.startTime, 'HH:mm:ss', new Date()),
          endTime: parse(workShiftSelected.endTime, 'HH:mm:ss', new Date()),
          breakStartTime: parse(workShiftSelected.breakStartTime, 'HH:mm:ss', new Date()),
          breakEndTime: parse(workShiftSelected.breakEndTime, 'HH:mm:ss', new Date()),
          note: workShiftSelected.note,
        });
      }
    }
  };

  setMode = () => {
    let mode;

    if (this.props.isCreate) {
      mode = 'create';
    } else if (this.props.isCopy) {
      mode = 'copy';
    } else if (this.props.isEdit) {
      mode = 'edit';
    } else if (this.props.isDetail) {
      mode = 'detail';
    }

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableCode: false,
        disableName: false,
        disableWorkTime: false,
        disableBreakTime: false,
        disableNote: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableCode: true,
        disableName: false,
        disableWorkTime: false,
        disableBreakTime: false,
        disableNote: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  createWorkShiftSubmit = async () => {
    const {
      code, name, note, startTime, endTime, breakEndTime, breakStartTime,
    } = this.state;

    try {
      const newWorkShift = await this.props.createWorkShift({
        code,
        name,
        note,
        startTime: format(startTime, 'HH:mm'),
        breakStartTime: format(breakStartTime, 'HH:mm'),
        breakEndTime: format(breakEndTime, 'HH:mm'),
        endTime: format(endTime, 'HH:mm'),
      });

      if (newWorkShift) {
        if (newWorkShift.success && newWorkShift.success === false) {
          await addNotification(
            'danger',
            I18n.t('BEE945' /* Novo Turno de Trabalho */),
            I18n.t('BEE946', { 0: code } /* Erro ao incluir o Turno de Trabalho %{0}! */),
            'top-right',
          );
        } else {
          await addNotification(
            'success',
            I18n.t('BEE945' /* Novo Turno de Trabalho */),
            I18n.t('BEE947', { 0: code } /* Novo Turno de Trabalho %{0} incluído com sucesso! */),
            'top-right',
          );

          this.props.history.push(ROUTES.WORK_SHIFT_LIST);
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE945' /* Novo Turno de Trabalho */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE945' /* Novo Turno de Trabalho */),
            I18n.t('BEE946', { 0: code } /* Erro ao incluir o Turno de Trabalho %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE945' /* Novo Turno de Trabalho */),
          I18n.t('BEE946', { 0: code } /* Erro ao incluir o Turno de Trabalho %{0}! */),
          'top-right',
        );
      }
    }
  };

  updateWorkShiftSubmit = async () => {
    const {
      name, workShiftId, note, startTime, endTime, breakStartTime, breakEndTime,
    } = this.state;

    try {
      const updWorkShift = await this.props.updateWorkShift({
        workShiftId,
        name,
        note,
        startTime: format(startTime, 'HH:mm'),
        breakStartTime: format(breakStartTime, 'HH:mm'),
        breakEndTime: format(breakEndTime, 'HH:mm'),
        endTime: format(endTime, 'HH:mm'),
      });

      if (updWorkShift) {
        if (updWorkShift.success && updWorkShift.success === false) {
          await addNotification(
            'danger',
            I18n.t('BEE948' /* Atualizar Turno de Trabalho */),
            I18n.t('BEE950', { 0: name } /* Erro ao atualizar o Turno de Trabalho %{0}! */),
            'top-right',
          );
        } else {
          await addNotification(
            'success',
            I18n.t('BEE948' /* Atualizar Turno de Trabalho */),
            I18n.t('BEE949', { 0: name } /* Atualização do Turno de Trabalho %{0} efetuado com sucesso! */),
            'top-right',
          );

          this.props.history.push(ROUTES.WORK_SHIFT_LIST);
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE948' /* Atualizar Turno de Trabalho */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE948' /* Atualizar Turno de Trabalho */),
            I18n.t('BEE950', { 0: name } /* Erro ao atualizar o Turno de Trabalho %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE948' /* Atualizar Turno de Trabalho */),
          I18n.t('BEE950', { 0: name } /* Erro ao atualizar o Turno de Trabalho %{0}! */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      code, name, startTime, endTime, breakStartTime, breakEndTime, note,
    } = this.state;

    const {
      mode, disableCode, disableName, disableWorkTime, disableBreakTime,
      disableNote, showCreate, showUpdate, showCancel,
    } = this.state;

    let title = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE945' /* Novo Turno de Trabalho */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE951' /* Editar Turno de Trabalho */);
    } else if (mode === 'detail') {
      title = I18n.t('BEE952' /* Detalhes Turno de Trabalho */);
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE13' /* Administração */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE25' /* Usuários */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE869' /* Turnos de Trabalho */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <Panel>
              <PanelHeader noButton />
              <PanelBody>
                <Form
                  noPanel
                  setValue={this.setValue}
                  inputs={(formContext) => ([
                    formContext.createInput(
                      code,
                      'code',
                      `${I18n.t('BEE82' /* Código */)}:`,
                      I18n.t('BEE3685' /* Informe o código do turno de trabalho */),
                      'text',
                      true,
                      disableCode,
                    ),
                    formContext.createInput(
                      name,
                      'name',
                      `${I18n.t('BEE83' /* Nome */)}:`,
                      I18n.t('BEE3737' /* Informe o nome do turno de trabalho */),
                      'text',
                      true,
                      disableName,
                    ),
                    formContext.createTimePicker(
                      startTime,
                      'startTime',
                      'Horario Inicio Turno:',
                      false,
                      disableWorkTime,
                    ),
                    formContext.createTimePicker(
                      breakStartTime,
                      'breakStartTime',
                      'Horario Inicio Intervalo:',
                      false,
                      disableBreakTime,
                    ),
                    formContext.createTimePicker(
                      breakEndTime,
                      'breakEndTime',
                      'Horario Fim Intervalo:',
                      false,
                      disableBreakTime,
                    ),
                    formContext.createTimePicker(
                      endTime,
                      'endTime',
                      'Horario Fim Turno:',
                      false,
                      disableWorkTime,
                    ),
                    formContext.createInput(
                      note,
                      'note',
                      `${I18n.t('BEE135' /* Observação */)}:`,
                      I18n.t('BEE136' /* Informe a observação */),
                      'text',
                      false,
                      disableNote,
                    ),
                  ])}
                />
              </PanelBody>
              <PanelFooter>
                <Link to={{ pathname: ROUTES.WORK_SHIFT_LIST, state: { dice: this.props.location.dice } }}>
                  {(showCancel
                    ? (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    )
                    : (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE137' /* Voltar */)}
                      </OneClickButton>
                    ))}
                </Link>
                {(showCreate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createWorkShiftSubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}
                    </OneClickButton>
                    )
                  )}
                {(showUpdate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateWorkShiftSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}
                    </OneClickButton>
                    )
                  )}
              </PanelFooter>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getWorkShift: (workShiftId) => dispatch(getWorkShift(workShiftId)),
  createWorkShift: (workShift) => dispatch(createWorkShift(workShift)),
  updateWorkShift: (workShift) => dispatch(updateWorkShift(workShift)),
  deleteWorkShift: (workShiftId) => dispatch(deleteWorkShift(workShiftId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkShiftForm));
